import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { scoops } from "@/mocks/scoops";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryGrid() {
  const countOf = (name: string) => scoops.filter((s) => s.category === name).length;

  return (
    <section className="mx-auto max-w-[1200px] px-4 py-14 md:px-8 md:py-16" aria-labelledby="category-heading">
      <div id="category-heading">
        <SectionHeading
          eyebrow="主题分类"
          title="按领域进入对应的求证档案"
          desc="不同领域的材料类型差别很大，我们把档案按领域分开归档，方便你直接找到关心的那一类。"
        />
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to="/scoops"
            className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:border-accent-400 hover:-translate-y-0.5"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-secondary-500 group-hover:text-background-50">
              <i className={`${cat.icon} text-[22px]`} aria-hidden="true"></i>
            </span>
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-base font-bold text-foreground-950">{cat.name}</h3>
                <span className="font-label text-[11px] text-foreground-400">{countOf(cat.name)} 篇</span>
              </div>
              <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-600">{cat.desc}</p>
            </div>
          </Link>
        ))}

        <div className="flex flex-col justify-center rounded-lg border border-dashed border-accent-400 bg-accent-50 p-5">
          <p className="font-heading text-base font-bold text-accent-900">没找到你的关注领域？</p>
          <p className="mt-1.5 text-[13px] leading-relaxed text-accent-800">
            直接把线索投给我们，注明涉及领域，编辑会判断是否立档求证。
          </p>
          <Link
            to="/contact"
            className="mt-4 inline-flex w-fit items-center gap-2 rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-600 whitespace-nowrap"
          >
            <i className="ri-send-plane-line" aria-hidden="true"></i>
            提交线索
          </Link>
        </div>
      </div>
    </section>
  );
}